import { gsap } from 'gsap';

class NumberGrid {
	constructor() {
		this.el = document.querySelector('[data-number-grid]');

		this.numbers = document.querySelectorAll('[data-grid-number]');
		this.middleNumbers = document.querySelectorAll('.c-grid-number--b');
		this.centralNumbers = document.querySelectorAll('.c-grid-number--central');

		this.shuffeling = false;
	}

	shuffle() {
		this.shuffeling = true;
		this.shuffeInterval = setInterval(() => {
			this.numbers.forEach((number) => {
				number.querySelector('span').innerHTML = parseInt(
					Math.random() * (number.getAttribute('data-max') - 1)
				);
			});
			if (!this.shuffeling) {
				clearInterval(this.shuffeInterval);
				this.numbers.forEach((number) => {
					number.querySelector('span').innerHTML = number.getAttribute('data-original-number');
				});
			}
		}, 150);
	}

	setToPreloader() {
		return new Promise((resolve) => {
			this.middleNumbers.forEach((number, index) => {
				const rect = number.getBoundingClientRect();
				let numberLeft = window.innerWidth / 2 - (rect.left + rect.width / 2);
				if (number.closest('.c-grid__column--a')) {
					// L
					numberLeft = window.innerWidth / 2 - (rect.left + rect.width / 2) - 20;
				}
				if (number.closest('.c-grid__column--b')) {
					// O
					numberLeft = window.innerWidth / 2 - (rect.left + rect.width / 2) - 6;
				}
				if (number.closest('.c-grid__column--c')) {
					// F
					numberLeft = window.innerWidth / 2 - (rect.left + rect.width / 2) + 17;
				}
				if (number.closest('.c-grid__column--d')) {
					// I
					numberLeft = window.innerWidth / 2 - (rect.left + rect.width / 2) + 20;
				}
				gsap.set(number, {
					x: numberLeft + 'px',
					onComplete: () => {
						if (index === this.middleNumbers.length - 1) {
							document.body.classList.add('body--preloader');
							document.body.classList.remove('body--hidden');
							this.startPreloader().then(() => {
								resolve();
							});
						}
					},
				});
			});
		});
	}

	startPreloader() {
		return new Promise((resolve) => {
			setTimeout(() => {
				this.shuffle();
				this.el.classList.add('c-grid--shownumbers');
				setTimeout(() => {
					resolve();
				}, 1000); // minimal duration of shuffle
			}, 1000); // duration of 42
		});
	}

	fromPreloaderToGrid() {
		return new Promise((resolve) => {
			this.middleNumbers.forEach((number) => {
				gsap.to(number, {
					x: 0,
					ease: 'expo.inOut',
					duration: 1.2,
					onBegin: () => {
						document.body.classList.remove('body--preloader');
					},
					onComplete: () => {
						resolve();
					},
				});
			});
		});
	}

	showCentralNumbers() {
		gsap.to(this.centralNumbers, {
			opacity: 1,
		});
	}

	hideCentralNumbers() {
		gsap.to(this.centralNumbers, {
			opacity: 0,
		});
	}

	setNumbersAbsoluteOnMobile() {
		document.body.classList.add('numbers-absolute');
	}

	setNumbersFixedOnMobile() {
		document.body.classList.remove('numbers-absolute');
	}

	show404() {
		this.shuffeling = true;
		clearInterval(this.shuffeInterval);
		this.numbers.forEach((number, index) => {
			if (index % 2 == 0) {
				number.querySelector('span').innerHTML = '4';
			} else {
				number.querySelector('span').innerHTML = '0';
			}
		});
	}
}

const numberGrid = new NumberGrid();
export default numberGrid;
